﻿import * as React from "react";
import { IBaseSectionProps } from "./IBaseSectionProps";

export const MetriSection: React.FunctionComponent<IBaseSectionProps> = (
    props,
): React.ReactElement => (
    <div className={`tab-section`}>
        <a href={`https://www.metricell.com`} target={`_none`}>
            <img
                alt={props.name}
                src={`/Images/Icon?icon=${props.moduleID}&folder=Module`}
            />
        </a>
    </div>
);
